import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import styles from './v2.module.css';

const CloseIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 256 256'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path d='M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z' />
  </svg>
);

function mentorLabel(mentorName) {
  const trimmed = mentorName?.trim();
  return trimmed || 'your mentor';
}

export default function PostConversationModalV2({ postConversationPath, mentorName, onDismiss, onClose }) {
  const history = useHistory();
  const mentor = mentorLabel(mentorName);

  const handleDismiss = () => {
    if (typeof onDismiss === 'function') onDismiss(false);
  };

  const handleStartSurvey = () => {
    history.push(postConversationPath);
    if (typeof onClose === 'function') onClose();
  };

  useEffect(() => {
    const handleKey = (event) => {
      if (event.key === 'Escape') handleDismiss();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) handleDismiss();
  };

  return (
    <div
      className={styles.backdrop}
      role='dialog'
      aria-modal='true'
      aria-labelledby='post-conversation-modal-title'
      onClick={handleBackdropClick}
    >
      <div className={styles.dialog}>
        <div className={styles.header}>
          <h2 id='post-conversation-modal-title' className={styles.title}>
            How was your conversation with {mentor}?
          </h2>
          <button type='button' className={styles.close_btn} aria-label='Dismiss' onClick={handleDismiss}>
            <CloseIcon />
          </button>
        </div>

        <div className={styles.body}>
          <p className={styles.description}>
            We hope your conversation with {mentor} helped you feel supported, understood, and less alone in your
            journey.
          </p>
          <p className={styles.description}>
            Your feedback directly shapes how we train and match mentors for future patients navigating a diagnosis like
            yours. It takes less than 2 minutes, and every response helps us make this program better for the next
            person who needs it.
          </p>
        </div>

        <div className={styles.footer}>
          <button type='button' className={styles.dismiss_btn} onClick={handleDismiss}>
            Dismiss
          </button>
          <button type='button' className={styles.start_btn} onClick={handleStartSurvey}>
            Start survey
          </button>
        </div>
      </div>
    </div>
  );
}
